// /accounts/$accountSlug/tenants/$tenantSlug — index route. Renders
// the tenant detail card; sibling routes (./secrets/...,
// ./ha-instances) mount in place of this when the operator clicks a tab.

import { createFileRoute } from "@tanstack/react-router";

import { TenantDetailPage } from "../features/tenants/TenantDetailPage";

export const Route = createFileRoute("/accounts/$accountSlug/tenants/$tenantSlug/")({
  component: TenantDetailRoute,
});

function TenantDetailRoute() {
  const { accountSlug, tenantSlug } = Route.useParams();
  return <TenantDetailPage accountSlug={accountSlug} tenantSlug={tenantSlug} />;
}
